import { render, staticRenderFns } from "./formEmpresas.vue?vue&type=template&id=81714c74&scoped=true"
import script from "./formEmpresas.vue?vue&type=script&lang=js"
export * from "./formEmpresas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81714c74",
  null
  
)

export default component.exports